import React from 'react';
import PropTypes from 'prop-types';

import { useAutoSaveOnBlur } from '../../hooks/useAutoSaveOnBlur';

import TextArea from '../TextArea/TextArea';

const TextAreaWithAutoSaveOnBlur = ({
    name,
    label,
    isRequired = false,
    isDisabled = false,
    value,
    originalValue,
    placeholder = 'Write here',
    handleChange: onChangeProp,
    handleSave: onSaveProp,
    height = 180,
}) => {
    const { wrapperRef, handleChange, handleSave, state, errorMessage } = useAutoSaveOnBlur({
        value,
        originalValue,
        isDisabled,
        isRequired,
        onSaveProp,
        onChangeProp,
        cssSelector: 'textarea',
    });

    return (
        <div ref={wrapperRef}>
            <TextArea
                name={name}
                value={value}
                label={label}
                isRequired={isRequired}
                state={state}
                errorMessage={errorMessage}
                onChange={handleChange}
                onBlur={handleSave}
                placeholder={placeholder}
                height={height}
            />
        </div>
    );
};

TextAreaWithAutoSaveOnBlur.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    isDisabled: PropTypes.bool,
    value: PropTypes.string,
    originalValue: PropTypes.string,
    placeholder: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    height: PropTypes.number,
};

export default TextAreaWithAutoSaveOnBlur;
